export default (list, key, value) => {
  let defaultItem = list.filter(item => item[key] === value)[0];
  defaultItem = defaultItem || list[0];

  return defaultItem[key];
};
